<template>
  <div id="brand-detail">
    <b-media
      vertical-align="center"
    >
      <template #aside>
        <b-img
          rounded
          class="product-info__image"
          :src="linkStaging(data.image_url, 50, 50)"
          :alt="data.name"
          @error="(event) => {
            event.target.src = require('@/assets/images/icons/broken-image.svg')
          }"
        /></template>
      <span class="font-weight-bold d-block">
        {{ data.name }}
      </span>
      <small class="text-muted">{{ data.user.email }}</small>
    </b-media>
    <hr class="my-1">
  </div>
</template>

<script>
import {
  BMedia,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BImg,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
